/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load LinkedIn event listeners
 *
 * https://www.linkedin.com/help/lms/answer/a425606?lang=en-US
 *
 * */

// Pixel load event listener
jQuery(document).on("pmw:load-pixels", () => {

	if (wpmDataLayer?.pixels?.linkedin?.partner_id && !wpmDataLayer?.pixels?.linkedin?.loaded) {
		if (wpm.consent.canPixelBeFired("marketing", "LinkedIn")) wpm.load_linkedin_pixel()
	}
})

// view search event
jQuery(document).on("pmw:browser:search", (event, payload) => {

	try {

		if(wpm.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: search event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})

// view_content event
jQuery(document).on("pmw:browser:view-item", (event, payload) => {

	try {
		if(wpm.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: view_content event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})

// add_to_list event
jQuery(document).on("pmw:browser:add-to-wishlist", (event, payload) => {

	try {
		if(wpm.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: add_to_list event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})

// add-to-cart event
jQuery(document).on("pmw:browser:add-to-cart", (event, payload) => {

	try {
		if(wpm.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: add_to_cart event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})


// start-checkout event
jQuery(document).on("pmw:browser:begin-checkout", (event, payload) => {

	try {
		if(wpm.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: start_checkout event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})

// View order received page event
jQuery(document).on("pmw:browser:purchase", (event, payload) => {

	try {
		if(wpm.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: purchase event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})

